import { memo } from 'react';

import CurrencyIcon from '@/assets/currency-icon.svg?react';
import { merge } from '@/components';
import { Logo } from '@/components/core';
import { VariantLogoProps } from '@/components/logos';
export type CurrencyLogoProps = VariantLogoProps;

const ICurrencyLogo = ({ className, ...rest }: CurrencyLogoProps) => {
  return (
    <Logo className={merge('bg-[#F3FEE7] text-[#3B7C0F]', className)} {...rest}>
      <CurrencyIcon />
    </Logo>
  );
};

export const CurrencyLogo = memo(ICurrencyLogo) as typeof ICurrencyLogo;
